import { Datum } from '../../DataSeries';


export class Tracker {
  /**
   * Track an Array to provide simple .lag functionality
   * 
   * Note:
   *   Lag calls are assumed to happen in the NEXT period, so lag(1)
   *   will return the last value on the array
   * 
   * @param {TimeSeries} trackingArray The TimeSeries to track
   * @param {Number} defaultValue Value to start series and impute
   */
  constructor(trackingArray, defaultValue = null) {
    this.defaultValue = defaultValue;
    this.array = trackingArray; // Passively track underlying by reference
  }

  lag(lag) {
    let length = this.array.length;

    if (lag <= 0) {
      throw Error('Lag should be a positive value');
    } else if (!Number.isInteger(lag)) {
      throw Error('Lag must be an integer value');
    } else if (lag > length) {
      return this.defaultValue;
    } else {
      let item = this.array[length - lag];
      if (item instanceof Datum) {
        return item.value;
      } else {
        return item;
      }
    }
   }
}